import React, { useEffect, useState } from 'react';
import { OmGlyph, Mandala, LotusFlower, DiamondDivider, RangoliCorner } from './svgs';
import { useScrollY } from './useParallax';
import './Hero.css';

export default function Hero() {
  const scrollY = useScrollY();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  const handleCTA = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="home">
      {/* Parallax background layers */}
      <div
        className="hero__bg-layer hero__bg-layer--far"
        style={{ transform: `translateY(${scrollY * 0.5}px)` }}
      />
      <div
        className="hero__bg-layer hero__bg-layer--mid"
        style={{ transform: `translateY(${scrollY * 0.3}px)` }}
      />
      <div
        className="hero__bg-layer hero__bg-layer--near"
        style={{ transform: `translateY(${scrollY * 0.15}px)` }}
      />

      {/* Mandala layers */}
      <div
        className="hero__mandala hero__mandala--bg"
        style={{ transform: `translateY(${scrollY * 0.2}px) rotate(${scrollY * 0.02}deg)` }}
      >
        <Mandala size={700} opacity={0.08} />
      </div>
      <div
        className="hero__mandala hero__mandala--mid"
        style={{ transform: `translateY(${scrollY * 0.1}px) rotate(${-scrollY * 0.015}deg)` }}
      >
        <Mandala size={450} opacity={0.12} />
      </div>

      {/* Corner decorations */}
      <div className="hero__corner hero__corner--tl">
        <RangoliCorner size={140} />
      </div>
      <div className="hero__corner hero__corner--tr">
        <RangoliCorner size={140} style={{ transform: 'scaleX(-1)' }} />
      </div>
      <div className="hero__corner hero__corner--bl">
        <RangoliCorner size={140} style={{ transform: 'scaleY(-1)' }} />
      </div>
      <div className="hero__corner hero__corner--br">
        <RangoliCorner size={140} style={{ transform: 'scale(-1,-1)' }} />
      </div>

      {/* Main content */}
      <div className={`hero__content ${loaded ? 'hero__content--visible' : ''}`}>
        {/* Lotus above title */}
        <div className="hero__lotus">
          <LotusFlower size={100} className="lotus-spin" />
        </div>

        <div className="hero__om-wrapper">
          <OmGlyph size={90} color="#F5C842" className="hero__om" />
        </div>

        <p className="hero__mantra devanagari">
          ॐ तत् सत् — ॐ असतो मा सद्गमय
        </p>

        <h1 className="hero__title cinzel">
          <span className="hero__title-line">Vedanagari</span>
          <span className="hero__title-sub devanagari">वेदनगरी आश्रम</span>
        </h1>

        <DiamondDivider color="#C9902A" />

        <p className="hero__tagline">
          A sanctuary for spiritual growth, devotion,<br />
          and community living at the sacred foot of Arunachala
        </p>

        <div className="hero__location">
          <span className="hero__location-dot" />
          <span className="cinzel">Tiruvannamalai, Tamil Nadu</span>
        </div>

        <div className="hero__ctas">
          <button className="hero__btn hero__btn--primary cinzel" onClick={() => handleCTA('#activities')}>
            Explore Activities
          </button>
          <button className="hero__btn hero__btn--secondary cinzel" onClick={() => handleCTA('#contact')}>
            Visit Ashram
          </button>
        </div>

        <div className="hero__scroll-hint" style={{ opacity: Math.max(0, 1 - scrollY / 200) }}>
          <div className="hero__scroll-line" />
          <span className="cinzel">Scroll</span>
        </div>
      </div>

      {/* Bottom fade */}
      <div className="hero__fade-bottom" />
    </section>
  );
}
